import { render, staticRenderFns } from "./WistiaVideo.vue?vue&type=template&id=08090910"
import script from "./WistiaVideo.vue?vue&type=script&lang=js"
export * from "./WistiaVideo.vue?vue&type=script&lang=js"
import style0 from "./WistiaVideo.vue?vue&type=style&index=0&id=08090910&prod&lang=scss"
import style1 from "./WistiaVideo.vue?vue&type=style&index=1&id=08090910&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports